import Vue from "vue";
import Router, { Route } from "vue-router";
import i18n from "@/i18n";
import store from "../store";
import { toLongLang, toShortLang } from "@/mixins/common-functions";
import { isMobile } from "@/util/mobile";
import { router as mobileRouter } from "@/router/router-mobile";
import { router as pcRouter } from "@/router/router-pc";
import { isAccessTokenValid, renewSession } from "@/usecase/token-operators.usecase";
import { parameterizedURLQuery } from "@/util/url-query.helper";
import { setMetaTitleOfLandingView, replaceTitleTab, setHtmlLang } from "@/util/router.helper";

Vue.use(Router);

const router = isMobile() ? mobileRouter : pcRouter;

router.beforeEach(async (to: Route, _: Route, next: (route?: string) => void) => {
  // route with language prefix
  const { lang } = to.params;

  if (lang === "en" || lang === "tw" || lang === "cn" || lang === "ko") {
    store.commit("data/setLanguage", toLongLang(lang));
    i18n.locale = toLongLang(lang);
    setHtmlLang(i18n.locale);
  } else if (lang === undefined) {
    if (i18n.locale === undefined) {
      store.commit("data/setLanguage", "ja-JP");
      i18n.locale = "ja-JP";
    }
    // redirect exsited route.push()
    const savedLang = i18n.locale;
    const short = toShortLang(savedLang);
    if (short !== undefined) {
      const prefixedPath = `/${short}${to.path === "/" ? "" : to.path}`;
      const hasPrefix = to.path === `/${short}` || to.path.startsWith(`/${short}/`);
      // Check prefix again
      if (hasPrefix) {
        return next();
      }
      if (to.query !== undefined && Object.keys(to.query).length > 0) {
        console.log(`to.path:${to.path}`);
        return next(`${prefixedPath}?${parameterizedURLQuery(to.query as { [Key: string]: string })}`);
      }
      return next(prefixedPath);
    }
    // next(`${to.path}`);
  } else {
    store.commit("data/setLanguage", "ja-JP");
    i18n.locale = "ja-JP";
    const pathes: RegExpMatchArray | null = to.path.match(`^/${lang}/(.*)`);
    if (pathes === null) return next();
    const jpPath = `/${pathes[1]}`;
    next(jpPath);
  }

  // replace title from router setting
  setMetaTitleOfLandingView(to);
  replaceTitleTab(to);

  // check routers meta
  const needAuthentication: boolean = to.matched.some(
    (record) => record.meta.requireLogin !== undefined && record.meta.requireLogin.length > 0,
  );

  if (!needAuthentication) {
    return next();
  }

  if (!(await isAccessTokenValid())) {
    if (!(await renewSession())) return next("/login");
  }

  return next();
});

/** for index handling */
router.afterEach((to) => {
  let robots = to.meta?.robots || "index,follow";
  if (to.path === "/place" || to.path === "/place/" || (to.path === "/map" && to.query.areaMenu)) {
    robots = "noindex,follow";
  }
  let tag = document.querySelector('meta[name="robots"]');
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", "robots");
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", robots);
});

export default router;
